import React, { useEffect } from "react";
import "./Looser_Modal.css";
import { Modal } from "react-bootstrap";

function Looser_Modal({ onHide, show, ...props }) {

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        if (onHide) {
          onHide();
        }
      }, 3000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [show, onHide]);

  return (
    <Modal
      {...props}
      show={show}
      onHide={onHide}
      centered
      size="sm"
      backdrop="static"
      className="Winner_Modal Looser_Modal Common_modal"
    >
      <Modal.Body>
        <div className="winner_content_holder Looser_Modal_content_holder">
          <div className="img_holder">
            <img
              src="/assets/images/looser_modal/bg.png"
              className="bg_img"
              alt="bg"
            />

            {/* Result */}
            <div className="result_box">
              <span className="number">2</span>
              <span className="result_color loose_box"></span>
              <span className="type">Small</span>
            </div>

            {/* Period */}
            <div className="period_text">
              Period: Trx Win 1 Min 123456789012
            </div>

            {/* Win Amount */}
            <div className="amount_box">
              <img
                src="/assets/images/icons/rupee.png"
                alt="coin"
                className="coin_icon"
              />
              <span>8,989</span>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Looser_Modal;